import { render, staticRenderFns } from "./DiffCollapserSection.vue?vue&type=template&id=333984da&scoped=true&"
import script from "./DiffCollapserSection.vue?vue&type=script&lang=js&"
export * from "./DiffCollapserSection.vue?vue&type=script&lang=js&"
import style0 from "./DiffCollapserSection.vue?vue&type=style&index=0&id=333984da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333984da",
  null
  
)

export default component.exports